import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-likert-scale-3',
  templateUrl: './disable-likert-scale-3.component.html',
  styleUrls: ['./disable-likert-scale-3.component.css'],
})
export class DisableLikertScale3Component {
  @Input() question!: Question;
}
